// extracted by mini-css-extract-plugin
export default {"container":"DatasetSideNavigation__container___DEqkg"};